import type { ICheckoutContext } from '@/types/context';
import { PaymentMethodEnum } from '@/types/common';
import { buildPaypalPaymentRequest, buildSavedPaypalPaymentRequest } from '@/utils/paypal';
import type { PayPalPaymentParams } from '@/types/paymentHandlers';
import type { BrainTreePaymentResponse } from '@/types/payment';

export const handlePayPalPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: (params: unknown) => Promise<unknown>,
  params?: PayPalPaymentParams
): Promise<BrainTreePaymentResponse> => {
  if (!params) {
    throw new Error('PayPal payment requires tokenization data parameter');
  }

  const paymentMethodSettings = checkout.paymentMethodsSettings.find(
    (pm) => pm.paymentMethodName === PaymentMethodEnum.PAYPAL
  );

  if (!paymentMethodSettings) {
    throw new Error('PayPal payment method settings not found');
  }

  // One-click: charge the vaulted PayPal token, no SDK tokenization.
  if (params.savedToken) {
    const savedPaypalAccount = checkout.card.savedPaypalAccount;
    if (!savedPaypalAccount) {
      throw new Error('Saved PayPal account not found');
    }
    return (await sendPaymentToServer(
      buildSavedPaypalPaymentRequest(savedPaypalAccount, paymentMethodSettings, checkout.customer?.email ?? '')
    )) as BrainTreePaymentResponse;
  }

  const { tokenizationData } = params;
  if (!tokenizationData) {
    throw new Error('PayPal payment requires tokenization data parameter');
  }

  return (await sendPaymentToServer(
    buildPaypalPaymentRequest(tokenizationData, paymentMethodSettings, params.shouldSaveCard ?? false)
  )) as BrainTreePaymentResponse;
};
